export const USER_APP_ROBOTS_PATH = '/user-app/robots';
/** Catalog + plan-request payment (POST select-plan / confirm-plan-payment). */
export const USER_SUBSCRIPTION_PLANS_PATH = '/user/subscription/plans';
/** Admin contract awaiting payment (POST contract-checkout/initiate / confirm). */
export const USER_CONTRACT_CHECKOUT_PATH = '/user/subscription/contract-checkout';
/** @deprecated Use USER_SUBSCRIPTION_PLANS_PATH */
export const USER_APP_SUBSCRIPTION_PLANS_PATH = USER_SUBSCRIPTION_PLANS_PATH;
export const USER_APP_MAPS_PATH = '/user-app/maps';
